import { ChatAltLight } from '@repo/go-icons';
import { ActionsBar, Checkbox, Tooltip } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { ImageBroadcastingWidgetState } from '../../model/ImageBroadcastingWidgetState';
import styles from '../Broadcast.module.scss';

type Props = {
  widgetState: ImageBroadcastingWidgetState;
};

export const VisibilityPanel = observer(function VisibilityPanel({ widgetState }: Props) {
  const { t } = useTranslation('imageBroadcast');
  const [open, setOpen] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const { broadcasts: isBroadcastVisible, comments: isCommentsVisible } = widgetState.visiblePanels;
  const isOnlyBroadcastVisible = isBroadcastVisible && !isCommentsVisible;
  const isOnlyCommentsVisible = !isBroadcastVisible && isCommentsVisible;

  useEffect(() => {
    if (open) {
      setTooltipOpen(false);
    }
  }, [open]);

  return (
    <Tooltip
      open={tooltipOpen && !open}
      onOpenChange={(value) => setTooltipOpen(value)}
      placement="left"
      title={t('visiblePanelsSelection')}
    >
      <ActionsBar.Item active={open} onClick={() => setOpen(true)}>
        <Tooltip
          open={open}
          trigger={['click']}
          onOpenChange={(value) => setOpen(value)}
          placement="left"
          title={
            <div className={styles.VisiblePanelsTooltip}>
              <Checkbox
                size="s"
                checked={isBroadcastVisible}
                disabled={isOnlyBroadcastVisible}
                onChange={(checked) => widgetState.setVisiblePanels({ broadcasts: checked })}
              >
                {t('broadcastPanel')}
              </Checkbox>
              <Checkbox
                size="s"
                checked={isCommentsVisible}
                disabled={isOnlyCommentsVisible}
                onChange={(checked) => widgetState.setVisiblePanels({ comments: checked })}
              >
                {t('commentsPanel')}
              </Checkbox>
            </div>
          }
        >
          <ChatAltLight />
        </Tooltip>
      </ActionsBar.Item>
    </Tooltip>
  );
});
